<bau365-breadcrumb
  [breadcrumbElements]="breadcrumbElements"
  [breadcrumbClickable]="breadcrumbClickable"></bau365-breadcrumb>
<div class="mdc-layout-grid">
  <div class="mdc-layout-grid__inner">
    <div class="mdc-layout-grid__cell mdc-layout-grid__cell--span-12">
      <section class="pre-headline">
        <div class="linktree">
          @if (post?.published_at) {
          {{ post?.published_at | date }}
          <span class="linktree__divider">|</span>
          } @if (post?.category === 'PRESS_RELEASE') {
          <ng-container i18n="@@featurePostDetails-postType-pressRelease">Pressemitteilung</ng-container>
          } @else {
          <ng-container i18n="@@featurePostDetails-postType-editorial">Redaktioneller Inhalt</ng-container>
          } @if (exhibitor) {
          <span class="linktree__divider">|</span>
          <a [routerLink]="['/fairs/' + exhibitor.fair_id + '/exhibitors/' + exhibitor.id]" class="linktree__link"
            >{{ exhibitor.name }}
          </a>
          }
        </div>
        <div class="topnavi__actions">
          <button mat-icon-button class="actions__link" (click)="trackShareButtonDialogOpened($event)">
            <mat-icon class="actions__icon">share</mat-icon>
          </button>
          <bau365-toggle-watchlist-item
            entityType="POST"
            [entityId]="post?.id"
            [pageContext]="'post-details'"
            [fairId]="post?.fair_id"></bau365-toggle-watchlist-item>
        </div>
      </section>
      <h1 class="post__title mat-headline-1">{{ post?.headline }}</h1>
      <section class="post__teaser" [innerHtml]="post?.summary | WYSIWYGTagFilter"></section>
    </div>
  </div>
</div>
